<template>
  <section class="min-h-screen bg-background text-primary px-6 py-10">
    <div class="mx-auto max-w-4xl card-primary space-y-6">
      <h1 class="text-3xl font-bold text-gold">Mentions legales</h1>
      <p class="text-sm text-secondary">Version: 2026-07-17</p>

      <div class="space-y-5 text-sm leading-6 text-secondary">
        <div>
          <h2 class="text-gold font-semibold">Editeur</h2>
          <p>Le site Quiestleplusriche est edite par TEIXEIRA Philippe, micro-entreprise.</p>
          <p>SIREN: 830751517</p>
          <p>SIRET: 83075151700020</p>
          <p>Adresse: 11 avenue des Freres Lumiere, 95240 Cormeilles-en-Parisis, France.</p>
          <p>TVA non applicable, article 293 B du Code general des impots.</p>
        </div>

        <div>
          <h2 class="text-gold font-semibold">Contact</h2>
          <p>Email: contact@quiestleplusriche.com</p>
        </div>

        <div>
          <h2 class="text-gold font-semibold">Responsable de publication</h2>
          <p>TEIXEIRA Philippe</p>
        </div>

        <div>
          <h2 class="text-gold font-semibold">Hebergement</h2>
          <p>
            HOSTINGER INTERNATIONAL LIMITED, societe privee a responsabilite limitee de droit chypriote,
            siege social: 61 Lordou Vironos str., 6023 Larnaca, Chypre.
          </p>
        </div>

        <div>
          <h2 class="text-gold font-semibold">Propriete intellectuelle</h2>
          <p>
            Les contenus, textes, elements graphiques, logos et codes presents sur le site sont proteges.
            Toute reproduction, representation, adaptation ou exploitation non autorisee est interdite.
          </p>
        </div>

        <div>
          <h2 class="text-gold font-semibold">Loi applicable</h2>
          <p>Le site et ses contenus sont soumis au droit francais.</p>
        </div>
      </div>
    </div>
  </section>
</template>
